import React from 'react';
import Spinner from '../web-common/components/Spinner';

const PageSpinner = () => <Spinner style={{ margin: '40vh auto' }}/>
export default PageSpinner;
